import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService } from "../../../../../services/data.service";
import { SpinnerService } from "shared-components";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-grid-estadisticas-etiquetador",
  templateUrl: "./grid-estadisticas-etiquetador.component.html",
})
export class GridEstadisticasEtiquetadorComponent implements OnInit {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public totalItems: number;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;
  public readonly visiblePages = 3;

  public data;

  public showPais = false;
  public showDenominacion = false;
  public showCampanya = false;
  public showEtiquetador = false;
  public showPorcentaje = false;

  public desPais;
  public desDenominacion;
  public desCampanya;
  public desEtiquetador;

  @Input() titulo: string;
  @Input() dataGrid: any;

  @Output() refresh = new EventEmitter<boolean>();
  @Output() hideTable = new EventEmitter<boolean>();

  constructor(
    private readonly _translate: TranslateService,
    private readonly _dataService: DataService,
    private readonly _spinnerService: SpinnerService
  ) {}

  ngOnInit() {
    /* this.getDataGrid(); */
    this.totalItems = this.dataGrid.length;
    this.showRightFields();
  }

  private showRightFields() {
    console.log("dataGrid", this.dataGrid);
    // Con que exista esa propiedad/no esté vacía en algún objeto, hay que mostrar ese campo
    this.dataGrid.forEach((object) => {
      if (object.desPais) {
        this.desPais = object.desPais;
        this.showPais = true;
      }
      if (object.numEtiquetadores || object.numero) {
        this.desEtiquetador = object.desEtiquetador;
        this.showEtiquetador = true;
      }
      if (object.porcentajeEtiquetadores || object.porcentaje) {
        this.showPorcentaje = true;
      }
      if (object.desDenominacion || object.strNumDenominaciones) {
        this.showDenominacion = true;
        this.desDenominacion = object.desDenominacion
          ? object.desDenominacion
          : object.strNumDenominaciones;
      }
      if (object.anyo) {
        this.showCampanya = true;
      }
    });
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  /* public getDataGrid() {
    let filters = {
      lsPaisId: this.dataGrid.paisId,
      lsDenominacionId: this.dataGrid.denominacionId,
      etiquetadorId: this.dataGrid.etiquetadorId,
    };
    this.desDenominacion = this.dataGrid.denominacion
      ? this.dataGrid.denominacion
      : "";
    this.desPais = this.dataGrid.pais ? this.dataGrid.pais : "";
    this.desEtiquetador = this.dataGrid.etiquetador
      ? this.dataGrid.etiquetador
      : "";
    this._spinnerService.showSpinner();
    this._dataService[this.dataGrid.service](filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          resp = resp.some((a) => a.lsEtqAnyoPaisDenominacionDto)
            ? resp
                .map((c) => c.lsEtqAnyoPaisDenominacionDto)
                .reduce((acc, curr) => acc.concat(curr), [])
            : resp;
          if (this.desPais == "")
            this.showPais = resp.some((a) => a.paisId) ? true : false;
          if (this.desDenominacion == "")
            this.showDenominacion = resp.some((a) => a.denominacionId)
              ? true
              : false;
          this.showCampanya = resp.some((a) => a.anyo) ? true : false;
          if (this.desEtiquetador == "")
            this.showEtiquetador = resp.some((a) => a.etiquetadorId)
              ? true
              : false;
          this.totalItems = resp.length;
          this.data = resp;
        }
      });
  } */

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.itemsPerPage * page;
  }

  public itemsPerPageChange(items) {
    this.currentPage = 1;
    this.itemsPerPage = items;
    this.firstItemList = 0;
    this.lastItemList = items;
  }

  public close() {
    /* this.refresh.emit(true); */
    this.hideTable.emit(true);
  }
}
